import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  djsPreview: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',

    '&.short': {
      '& .djPreview': {
        '& .content': {
          display: 'none',
        },
      },
    },

    '& .djPreview': {
      '& .djName': {
        maxWidth: '70px',

        '@media screen and (min-width: 1441px)': {
          maxWidth: '140px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        gap: '6px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '6px',
    },
  },
}));

export default useStyles;
